import ModalBase from "../ModalBase";
import { find as ramdaFind, propEq as ramdaPropEq } from "ramda";
import { formatCurrency } from "../../shared/utils";

import moment from "moment";

const sprintf = (str, ...argv) => !argv.length ? str :
	sprintf(str = str.replace(sprintf.token || "{}", argv.shift()), ...argv);

const PriceAlertModalMessages = [
	{
		status: "EXPIRED",
		content: `<p class="lead">A data do voo que você procura já passou. Faça uma nova pesquisa e crie um novo alerta.</p>`
	},
	{
		status: "ENDED",
		content: `<p class="lead">Não encontramos voos com o preço que você procura. Busque outra opção pra sua viagem!</p>`
	},
	{
		status: "CHANGED",
		content: `<p class="lead no-bold">Infelizmente, o voo que te enviamos mudou e está diferente do que você procura. Mas encontramos outra opção pra você! <strong>Confira antes de finalizar sua compra.</strong></p>`
	},
	{
		status: "DECREASE",
		content: `<p class="lead">Seu voo está {} mais barato. Aproveite agora!</p>`
	},
	{
		status: "INCREASE",
		content: `<p class="lead">Seu voo aumentou {}, mas continua dentro do valor que você procura. Aproveite!</p>`
	},
	{
		status: "ERROR",
		content: `<p class="lead">Infelizmente, tivemos uma instabilidade técnica, mas já estamos trabalhando nisso. Por favor, volte mais tarde!</p>`
	}
];

const PriceAlertRedirectModal = ({ isOpen, data, modalInstance }) => {
	if (!isOpen) {
		return null;
	}

	const { result: status, priceDifference } = data;

	modalInstance.setContent("");
	modalInstance.setFooterContent("");

	const modalOptions = ramdaFind(ramdaPropEq("status", status))(PriceAlertModalMessages);

	let redirectLink = `/`;

	if (["CHANGED", "DECREASE", "INCREASE"].indexOf(status) > -1) {
		const { checkoutUrl } = data;

		redirectLink = checkoutUrl || "https://www.maxmilhas.com.br";

		if (status === "INCREASE" || status === "DECREASE") {
			modalInstance.setContent(sprintf(modalOptions.content, formatCurrency(priceDifference)));
		} else {
			modalInstance.setContent(modalOptions.content);
		}
	} else {
		if (status === "ENDED") {
			const { tripType, from: iataFrom, to: iataTo, outboundDate, inboundDate, adults, children, infants, cabin } = data;

			redirectLink = `/busca-passagens-aereas/${tripType}/${iataFrom}/${iataTo}/${moment.utc(outboundDate).format("YYYY-MM-DD")}`;

			if (inboundDate) {
				redirectLink = `${redirectLink}/${moment.utc(inboundDate).format("YYYY-MM-DD")}`;
			}

			redirectLink = `${redirectLink}/${adults}/${children}/${infants}/${cabin}`;
		}

		modalInstance.setContent(modalOptions.content);
	}

	modalInstance.addFooterBtn("OK", "btn btn-success", function () {
		modalInstance.close();
		window.location = redirectLink;
	});

	modalInstance.open();

	return null;
};

export default ModalBase(PriceAlertRedirectModal);
